<div class="main">
	<app-ivi-error-screen *ngIf="errorFlag" [errorCode]="errorCode" (retry)="ngOnInit()"
		[page]="pageName"></app-ivi-error-screen>
	<div class="top-section" style="background-image: url('{{ planDetails.featurePageBannerImage }}');">
		<div class="flexi-content">
			<div class="description-container">
				<h1>{{ planDetails?.packageDisplayName | translate }}</h1>
				<p>{{ planDetails?.description | translate }}</p>
			</div>
			<div class="image-container1">
				<img src="../../../assets/IVI/featurePage/car.png" alt="car">
			</div>
			<div class="status-container">
				<div class="status-label">
					{{ planDetails.planDisplayName | translate }}
				</div>
				<p>{{ promoMessage | translate: { rate: packagePrice, CompanionApp: appName } }}</p>
			</div>
		</div>
		<div class="image-container2">
			<img src="../../../assets/IVI/featurePage/car.png" alt="car">
		</div>
	</div>
	<div class="bottom-section">
		<p>
			{{ planInfo | translate: {packageName: planDetails.packageDisplayName, Companionapp: appName} }}
		</p>

		<div class="feature-tiles">
			<div class="tile" *ngFor="let feature of planDetails?.featureList.features; trackBy: trackByFeature">
				<img [src]="feature.logo" alt="{{ feature.heading }}">
				<div class="tile-description">
					<h6>{{ feature.heading | translate }}</h6>
					<p>{{ feature.description | translate }}</p>
				</div>
			</div>
		</div>

		<div class="buttons">
			<div class="button" (click)="goToQRCode()" role="button" tabindex="0" aria-label="Continue to QR code" (keydown.enter)="goToQRCode()" (keydown.space)="$event.preventDefault(); goToQRCode()">
				{{
				('OPEN_APP' | translate: {Companionapp: appName})
				}}
			</div>
		</div>
	</div>
</div>
